<template>
  <div>
      <div class="form-container ou-donation-form">
          <div class="holder">
              <PaymentForm class="form-horizontal">
                  <FormSection title="Donation Amount">
                      <div>
                          <AmountSelector/>
                          <ErrorLabel field="amount" />
                      </div>
                  </FormSection>
                  <FormSection title="Donation Frequency">
            <div class="frequency">
              <PaymentOptions addSplit addMonthly monthlyText="Recurring Monthly Gift" />
            </div>
            <TransactionFee  v-if="form.amount"/>
          </FormSection>
                  <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.ou.org/privacy-policy/"/>
                  </FormRow>  
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow>
              <Receipt :receipts="['us', 'israel', 'canadian']" />
            </FormRow>
            <FormRow inline>
              <FormCol field="card" :showLabel="false" />
            </FormRow>
          </FormSection>
          <PaymentButton showAmount />
        </PaymentForm>
          </div>
      </div>
  </div>
  </template>

  <script lang="ts">
  import { computed, defineComponent, onMounted, ref, watch } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

  export default defineComponent({
    setup() {
      const { setValue, getValue, form } = usePaymentForm();
     

      return {
       getValue,
      form,
      setValue,
      }
    },
  })
  </script>
  <style scoped lang="scss">
  .card-img {
    display: flex;
    img {
      height: 23px;
    }
  }


.ou-donation-form ::v-deep
  .styled-radio-container.styled-radio-container--ou-donation.row{

    .radio-part{
      @media only screen and (min-width: 720px) {
    min-width: 32% !important;
    max-width: 32% !important;
  }
    }

  }


  h3{
    font-size: 20px;
    text-align: center;
    font-weight: 600;
    padding-bottom: 30px;
    padding-top: 10px;
    @media only screen and (min-width: 720px) {
      font-size: 20px;
    text-align: center;
    font-weight: 600;
    padding-bottom: 30px;
    padding-top: 10px;
    }
  }



  ::v-deep
  .styled-radio--ou-donation.styled-radio
  input[type="radio"]
  + label[data-amount="360"] {
  &:after {
    content: "*";
    font-size: 11px;
    padding-left: 2px;
  }
}

.alltorah__honor{
  font-size: 14px;
  padding-bottom: 15px;
}
  </style>

